import React from 'react';
import PropTypes from 'prop-types';
import {
  Heading,
  Box,
} from '../../coreui';

const PageHeading = ({
  title,
}) => {
  return (
    <Box
      pt={[0, 40]}
      px={[10, 25]}
      w={1}
    >
      <Box
        pt={28}
        w={1}
      >
        <Heading
          type="H2"
          m={0}
          textTransform="uppercase"
          display="block"
          w={1}
          align="center"
          color="gray.8"
          weight="light"
        >
          { title }
        </Heading>
      </Box>
    </Box>
  );
};

PageHeading.propTypes = {
  title: PropTypes.string,
};

export default PageHeading;
